// extracted by mini-css-extract-plugin
export default {"simpleButton":"SimpleButton_simpleButton__Cay-t","icon":"SimpleButton_icon__D-TCG","isDisabled":"SimpleButton_isDisabled__QsOg-"};